<template>
  <div>
    <div v-if="modal">
      <vModalFull>
        <div
          class="tw-fixed tw-top-0 tw-left-0 tw-w-screen tw-h-screen tw-z-50 tw-flex tw-items-center tw-justify-center tw-text-center"
        >
          <div class="tw-w-5/6 tw-p-8 tw-mx-auto tw-items-center">
            <div class="tw-font-semibold tw-text-5xl tw-text-center">
              {{ timecount }}
            </div>
            <div class="tw-text-4xl tw-my-10">Tem alguem ai ?</div>
            <div class="tw-p-5">
              <button
                class="btnCustom tw-p-10 tw-text-4xl tw-uppercase tw-rounded-2xl"
                @click="confirmarAtividade()"
              >
                SIM, ESTOU AQUI
              </button>
            </div>
          </div>
        </div>
      </vModalFull>
    </div>
  </div>
</template>

<script>
import etapaLabel from "@/constants/etapaCompra";
import timesheet from "@/constants/timeout_page";
import { db, removeCodeFirebase, setEtapaCompra } from "../service/firebase";
import vModalFull from "./vModalFull.vue";
import { RestartTotem } from "@/utils/utilsTotem";
import { deveAdiarManutencao } from "@/service/purchaseSession";
import { manutencaoEfetiva } from "@/service/totemOperation";
import { canRecordTimeoutAbandonment, expirePurchaseByTimeout } from "@/service/purchaseTimeout";
import { comTimeout } from "@/utils/promiseTimeout";
export default {
  name: "vTimeout",
  components: {
    vModalFull,
  },
  props: {
    segundos: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      modal: false,
      userAtivo: false,
      timecount: 0,
      timeoutComponent: {},
      timeoutModal: {},
      timeoutRegressivo: {},
      timeoutName: "",
      timeoutExpirado: false,
    };
  },
  beforeDestroy() {
    clearTimeout(this.timeoutRegressivo);
    clearTimeout(this.timeoutModal);
    clearTimeout(this.timeoutComponent);
  },
  computed: {
    GET_AFK() {
      return this.$store.getters["totem/getAFK"];
    },
  },
  watch: {
    GET_AFK: {
      immediate: true,
      handler(val) {
        if (val === true) {
          if (!this.modal) {
            this.iniciarTudo();
          }
        } else {
          if (!this.modal) {
            this.destroiTimer();
          }
        }
      },
    },
  },
  methods: {
    iniciarTudo() {
      this.timeoutExpirado = false;
      this.timecount = timesheet.TIME_MODAL;
      this.iniciaContagemDoComponent();
      this.timeoutName = this.$store.getters["compra/getCompra"].etapa;
    },
    destroiTimer() {
      this.userAtivo = true;
      this.modal = false;
      this.timecount = timesheet.TIME_MODAL;
      clearTimeout(this.timeoutRegressivo);
      clearTimeout(this.timeoutModal);
      clearTimeout(this.timeoutComponent);
    },
    confirmarAtividade() {
      this.destroiTimer();
    },
    timeModal() {
      if (this.timecount <= 0) {
        clearTimeout(this.timeoutRegressivo);
        this.expiraSessao();
        return false;
      }
      this.timecount -= 1;
      this.timeoutRegressivo = setTimeout(() => {
        if (!this.userAtivo) {
          clearTimeout(this.timeoutRegressivo);
          this.timeModal();
        } else {
          clearTimeout(this.timeoutRegressivo);
        }
      }, 1000);
    },
    expiraSessao() {
      if (this.timeoutExpirado) return;
      // O provedor pode confirmar depois do timeout de inatividade. Enquanto
      // manutenção aguarda a cobrança/aprovação, somente seu resultado decide
      // a saída; não expirar nem limpar uma transação que ainda pode ser paga.
      if (
        manutencaoEfetiva(this.$store.getters["totem/getTotem"]) &&
        deveAdiarManutencao(this.$store, this.$route.path)
      ) {
        this.destroiTimer();
        return;
      }
      this.timeoutExpirado = true;
      const compra = this.$store.getters["compra/getCompra"];
      this.timecount = timesheet.TIME_MODAL;
      this.modal = false;
      clearTimeout(this.timeoutRegressivo);
      clearTimeout(this.timeoutModal);
      if (
        this.$store.getters["compra/getCompra"].etapa ==
        etapaLabel.AGRADECIMENTO
      ) {
        removeCodeFirebase();
        setEtapaCompra(etapaLabel.AGRADECIMENTO);
        RestartTotem();
      } else {
        if (!canRecordTimeoutAbandonment(compra, this.$route.path)) {
          this.destroiTimer();
          return;
        }
        const compraId = compra.id;
        const codigoCapturado = typeof compra.code === "string" ? compra.code : "";
        const totemId = this.$store.getters["totem/getTotem"]?.id;
        const path = this.$route.path;
        const endedAt = new Date();
        let aceitaCallback = true;
        const mesmoContexto = () =>
          !this._isDestroyed && this.$route.path === path &&
          this.$store.getters["compra/getCompra"]?.id === compraId &&
          this.$store.getters["totem/getTotem"]?.id === totemId;
        const voltarHome = (limparCodigo = true) => {
          if (!mesmoContexto() || !canRecordTimeoutAbandonment(
            this.$store.getters["compra/getCompra"], path
          )) return;
          if (limparCodigo) removeCodeFirebase();
          this.$router.push("/cabine/home").catch(() => {});
        };
        // A transação confere a aprovação remota antes de expirar. O teto
        // evita prender a tela sem internet; callbacks tardios não mexem na
        // nova compra e a falha de rede não inventa um abandono comprovado.
        comTimeout(expirePurchaseByTimeout(
          db, path, compraId, totemId, endedAt,
          () => aceitaCallback && mesmoContexto()
        ), { ms: 5000, rotulo: "encerramento por inatividade" }).then((expirou) => {
          if (expirou && aceitaCallback) {
            // O listener pode abrir a Home e criar outra compra antes deste
            // retorno. O código capturado pertence apenas à compra encerrada.
            removeCodeFirebase(codigoCapturado);
            voltarHome(false);
          }
        }).catch(() => {
          aceitaCallback = false;
          console.warn("Não foi possível registrar o encerramento por inatividade.");
          voltarHome();
        }).finally(() => {
          aceitaCallback = false;
        });
        return;
      }

      // .catch: estando já na Home, o vue-router rejeita com
      // NavigationDuplicated e a rejeição não tratada subia como erro global.
      if (this.$route.path !== "/cabine/home") {
        this.$router.push("/cabine/home").catch(() => {});
      }
    },
    iniciaContagemDoModal() {
      this.modal = true;
      this.$emit("modal-show");
      let prod_time = timesheet.TIME_MODAL * 1000;
      this.timeModal();
      this.timeoutModal = setTimeout(() => {
        if (!this.userAtivo) {
          clearTimeout(this.timeoutModal);
          this.expiraSessao();
        } else {
          clearTimeout(this.timeoutModal);
        }
      }, prod_time);
    },
    iniciaContagemDoComponent() {
      //PRIMEIRO
      let prod_time = this.segundos * 1000;
      this.userAtivo = false;
      this.timeoutComponent = setTimeout(() => {
        clearTimeout(this.timeoutComponent);
        this.iniciaContagemDoModal();
      }, prod_time);
    },
  },
};
</script>

<style lang="scss" scoped>
.btnCustom {
  background-color: #988fc4;
}
</style>
